module.exports = __webpack_public_path__ + "static/media/jackpot-main-background.3236fb15.png";